import React, { useState } from 'react';
import './TryOnIframe.css';

function TryOnIframe() {
  const [activeTab, setActiveTab] = useState('app1');

  const apps = {
    app1: {
      title: 'Try On Your Style with Haute-u AR (Version 1)',
      url: 'https://studio--styleswap-hn4w2.us-central1.hosted.app/'
    },
    app2: {
      title: 'Explore Jewelry Tryon AR (Version 0)',
      url: 'https://spiffy-bubblegum-d3af1a.netlify.app/' // Replace with actual URL
    }
  };

  return (
    <div id="app-try-on" className="tryon-iframe-section">
      <div className="tryon-iframe-background"></div>
      <div className="tryon-iframe-overlay"></div>
      <h1 className="tryon-iframe-title">Try On Feature</h1>
      
      <div className="tab-buttons">
        <button
          className={activeTab === 'app1' ? 'active' : ''}
          onClick={() => setActiveTab('app1')}
        >
          Try-On App
        </button>
        <button
          className={activeTab === 'app2' ? 'active' : ''}
          onClick={() => setActiveTab('app2')}
        >
          Jewelry Try-On AR
        </button>
      </div>

      <div className="tryon-iframe-container">
        <h2 className="tryon-heading">{apps[activeTab].title}</h2>
        <iframe
          title={apps[activeTab].title}
          src={apps[activeTab].url}
          className="tryon-iframe"
          allow="camera; microphone"
          frameBorder="0"
          allowFullScreen
        ></iframe>
      </div>
    </div>
  );
}

export default TryOnIframe;
